import axios from "axios";

let API_BASE = "";

// Διαβάζει το backend URL από το backend_url.json κάθε φορά που χρειάζεται
export async function getApiBase() {
  if (API_BASE) return API_BASE;
  try {
    const res = await fetch("/backend_url.json");
    if (res.ok) {
      const { backend_url } = await res.json();
      if (backend_url) {
        API_BASE = backend_url;
        return API_BASE;
      }
    }
    throw new Error("No backend_url found!");
  } catch (e) {
    console.error("No backend_url.json available", e);
    throw e;
  }
}

function getAxiosInstance(baseURL) {
  return axios.create({
    baseURL,
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "1",
    },
  });
}


export async function sendMessage({ text, session_id, gender, lang }) {
  console.log("sendMessage CALLED", { text, session_id, gender, lang });
  const apiBase = await getApiBase();
  const axiosInstance = getAxiosInstance(apiBase);
  const res = await axiosInstance.post("/api/message", {
    text,
    session_id,
    gender,
    lang,
    ui_lang_debug: lang, // <-- προσωρινό
  });
  return res.data;
}



export async function getPsychometricQuestions({ lang = "el", test_type = "" } = {}) {
  const apiBase = await getApiBase();
  const axiosInstance = getAxiosInstance(apiBase);
  const params = {};
  if (lang) params.lang = lang;
  if (test_type) params.test_type = test_type;
  const res = await axiosInstance.get("/api/questions", { params });
  return res.data;
}

export async function sendPsychometricAnswer({ user_id, question_id, answer }) {
  const apiBase = await getApiBase();
  const axiosInstance = getAxiosInstance(apiBase);
  const res = await axiosInstance.post("/api/answer", {
    user_id,
    question_id,
    answer,
  });
  return res.data;
}

export async function updateUserProfile({ session_id, name, email, phone, location }) {
  const apiBase = await getApiBase();
  const axiosInstance = getAxiosInstance(apiBase);
  const res = await axiosInstance.post("/api/user/update_user_profile", {
    session_id,
    name,
    email,
    phone,
    location,
  });
  return res.data;
}

// Αν θες να διαβάζεις και WordPress posts από κάποιο σταθερό API
const WP_API_BASE = "https://brainstorm-visions.com/en/wp-json/wp/v2";

export async function getWpPosts() {
  const res = await axios.get(`${WP_API_BASE}/posts`);
  return res.data;
}


// Π.χ. Custom API function:
export async function getUserProfile(session_id) {
  const apiBase = await getApiBase();
  const axiosInstance = getAxiosInstance(apiBase);
  const res = await axiosInstance.get(`/api/user/profile`, {
    params: { session_id }
  });
  return res.data;
}
